<template>
    <ies-form-field :field="field">
        <textarea :id="this.field.fieldName + '_textarea'" :name="this.field.fieldName" type="text" v-model="input" v-on:keyup="updateField()" :disabled="this.field.disabled">
        </textarea>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-text',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
            input: this.field.value || this.field.oldValue,
        }
    },
    mounted: function(){
		this.adjustComponentHeight();
        console.log(this.field);
    },
    methods: {
        updateField: function(){
            this.field.value = this.input
        },

		adjustComponentHeight: function() {
			var self = this;
			var textarea = document.getElementById(self.field.fieldName + '_textarea');
			var minHeight = 100;
			console.log(self.field.fieldName + '_textarea');
			console.log(Math.max(textarea.scrollHeight, minHeight));
  			textarea.style.height = "";
			textarea.style.height = (Math.max(textarea.scrollHeight, minHeight) + 5) + "px";
		}
    }
}
</script>


